export default __webpack_public_path__ + "static/media/9c.ad5f0e6e.png";